import ATB from "assets/atb-financial-logo.webp"
import BMO from "assets/bmo-logo.webp"
import CIBC from "assets/cibc-logo.webp"
import DesJardins from "assets/desjardins-logo.webp"
import BanqueLauretienne from "assets/banque-laurentienne-logo.webp"
import BanqueManuvie from "assets/banque-manuvie-logo.webp"
import Meridian from "assets/Meridian_Logo.webp"
import MotusBank from "assets/motus_bank_logo.webp"
import Hsbc from "assets/Hsbc-logo.webp"
import BanqueNationale from "assets/banque-nationale-logo.webp"
import PC from "assets/pc-financial-logo.webp"
import PeoplesTrust from "assets/peoples-trust.webp"
import RBC from "assets/RBC-logo.webp"
import BanqueScotia from "assets/banque-scotia-logo.webp"
import Siimpli from "assets/Simplii-financial-logo.webp"
import Tangerine from "assets/tangerine-logo.webp"
import TD from "assets/TD-logo.webp"

export const banks = [
  {
    link: "https://www.atb.com/",
    image: <img src={ATB} alt="ATB financial" />,
  },
  {
    link: "https://www.bmo.com/",
    image: <img src={BMO} alt="BMO" />,
  },
  {
    link: "https://www.cibc.com/",
    image: <img src={CIBC} alt="CIBC" />,
  },
  {
    link: "https://www.desjardins.com/",
    image: <img src={DesJardins} alt="Desjardins" />,
  },

  { link: "https://www.hsbc.ca", image: <img src={Hsbc} alt="HSBC" /> },

  {
    link: "https://www.banquelaurentienne.ca/",
    image: <img src={BanqueLauretienne} alt="Banque Lauretienne" />,
  },
  {
    link: "https://www.banquemanuvie.ca/",
    image: <img src={BanqueManuvie} alt="Banque Manuvie" />,
  },
  {
    link: "https://www.meridiancu.ca/",
    image: <img src={Meridian} alt="Meridian" />,
  },
  {
    link: "https://www.motusbank.ca/",
    image: <img src={MotusBank} alt="Motus Bank" />,
  },
  {
    link: "https://www.bnc.ca/",
    image: <img src={BanqueNationale} alt="Banque Nationale" />,
  },
  {
    link: "https://www.pcfinancial.ca/",
    image: <img src={PC} alt="PC financial" />,
  },
  {
    link: "https://www.peoplestrust.com/",
    image: <img src={PeoplesTrust} alt="Peoples trust" />,
  },
  {
    link: "https://www.rbcroyalbank.com/",
    image: <img src={RBC} alt="RBC" />,
  },
  {
    link: "https://www.scotiabank.com/",
    image: <img src={BanqueScotia} alt="Banque scotia" />,
  },
  {
    link: "https://www.simplii.com/",
    image: <img src={Siimpli} alt="Siimpli Financial" />,
  },
  {
    link: "https://www.tangerine.ca/",
    image: <img src={Tangerine} alt="Tangerine" />,
  },
  { link: "https://www.td.com/", image: <img src={TD} alt="TD" /> },
]
